import React, {useState, useEffect} from 'react';

import style from './totalProductCount.scss';

const MORIA_TOTAL_PRODUCT_COUNT_CHANGE_EVENT = 'moria.totalProductCount.onChange';

const TotalProductCount = ({totalProductCount: totalProduct}) => {
  const [totalProductCount, setTotalProductCount] = useState(totalProduct);

  useEffect(() => {
    window?.HbEventBus?.on(MORIA_TOTAL_PRODUCT_COUNT_CHANGE_EVENT, ({totalProductCount}) => {
      setTotalProductCount(totalProductCount);
    });
  }, []);

  return (
    <div className={style.totalProductCount}>
      ({totalProductCount >= 10000 ? '10.000+' : totalProductCount} ürün)
    </div>
  );
};

export default TotalProductCount;
